import React, { useEffect, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import FollowUp from '../../../../../../components/FollowUp';
import { getMessages } from '../../../../../../services/followup';
import MessageSender from '../../../../../../components/MessageSender';
import ClaimInfoHeader from '../../ClaimInfoHeader';
import styled from 'styled-components';

const CLAIM_UPDATES_ACCENT_COLOR = '#59249B';

const SectionLabel = styled.div`
  color: #2f3441;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export type FollowUpModalProps = {
  id: string;
  claim: any;
  isBlocked?: boolean;
};

const FollowUpTab = (props: FollowUpModalProps) => {
  const { id, claim } = props; // , setUnread, unread
  const [messages, setMessages] = useState<any[]>([]);
  const [totalMessages, setTotalMessages] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);

  const handleMessages = async () => {
    const response = await getMessages(id, page);
    const { data, count } = response;
    setMessages([...data]);
    setTotalMessages(count);
    setIsLoading(false);
  };

  useEffect(() => {
    handleMessages();
  }, [id]);

  return (
    <>
      {isLoading ? (
        <Dimmer active={isLoading} inverted>
          <Loader content="Carregando mensagens..." />
        </Dimmer>
      ) : (
        <>
          <ClaimInfoHeader claim={claim} />
          <SectionLabel>Followup</SectionLabel>
          {messages.length > 0 ? (
            <FollowUp
              messages={messages}
              id={id}
              isBlocked={props.isBlocked}
              totalMessages={totalMessages}
              page={page}
              setPage={setPage}
              accentColor={CLAIM_UPDATES_ACCENT_COLOR}
              hideSendIcon
              showComposerDivider
              showPendingFields
              disableOwnScroll
            /> // setUnread={setUnread} unread={unread}
          ) : (
            <MessageSender
              id={id}
              isBlocked={props.isBlocked}
              accentColor={CLAIM_UPDATES_ACCENT_COLOR}
              hideSendIcon
              showComposerDivider
              showPendingFields
            />
          )}
        </>
      )}
    </>
  );
};

export default FollowUpTab;
